// extracted by mini-css-extract-plugin
module.exports = {"u-fullWidth":"style_u-fullWidth__1hu7i","u-shrinkAll":"style_u-shrinkAll__16loP","Timer":"style_Timer__3kL-Y","TimerCounter":"style_TimerCounter__36xn9"};